
































































import { RecurrenceIntervention } from "../../../models/RecurrenceIntervention";
import { Intervention } from "../../../models/Intervention";
import { DateUtils } from "../../../utils/DateUtils";
import OptionSelect from "../../../core/Forms/OptionSelect.vue";
import FrequenceDaysCustomisation from "./FrequenceDaysCustomisation.vue";

export default {
    name: "FrequenceDaysSelection",
    components: { FrequenceDaysCustomisation, OptionSelect },
    props: {
        value: RecurrenceIntervention.Frequence,
        recurrenceIntervention: RecurrenceIntervention,
    },
    data() {
        return {
            frequence: null,
            weekDaysOptions: {},
            monthOptions: DateUtils.Months,
            occurrenceHebdoOptions: RecurrenceIntervention.OccurrenceHebdo,
            selectedOccurrenceHebdo:
                RecurrenceIntervention.EOccurrenceHebdo.even,
            occurrenceOptions: RecurrenceIntervention.Occurrence,
        };
    },
    created() {
        this.frequence = this.value;
        if (this.frequence.isSemiweekly()) {
            let jour = _.first(this.frequence.jours);
            if (jour) {
                this.selectedOccurrenceHebdo = jour.occurrence;
            }
        }
    },
    methods: {
        show() {
            return (
                this.frequence &&
                this.frequence.frequence != Intervention.EFrequence.None
            );
        },
        isEditable(): boolean {
            return (
                this.frequence &&
                this.frequence.frequence != Intervention.EFrequence.None &&
                this.frequence.frequence !=
                    Intervention.EFrequence.DuLundiAuSamedi &&
                this.frequence.frequence !=
                    Intervention.EFrequence.DuLundiAuVendredi
            );
        },
        // Data
        initDaysList() {
            let self = this;
            this.weekDaysOptions = _.cloneDeep(DateUtils.WeekDays);
            this.weekDaysOptions[7] =
                this.weekDaysOptions[DateUtils.EWeekDays.sunday]; // put sunday at the end of the list
            delete this.weekDaysOptions[DateUtils.EWeekDays.sunday];
            if (
                this.frequence.frequence ==
                Intervention.EFrequence.DuLundiAuVendredi
            ) {
                _.forEach(this.weekDaysOptions, function (day) {
                    day.selected =
                        day.id != DateUtils.EWeekDays.sunday &&
                        day.id != DateUtils.EWeekDays.saturday;
                });
                this.onDaySelection();
            } else if (
                this.frequence.frequence ==
                Intervention.EFrequence.DuLundiAuSamedi
            ) {
                _.forEach(this.weekDaysOptions, function (day) {
                    day.selected = day.id != DateUtils.EWeekDays.sunday;
                });
                this.onDaySelection();
            } else {
                _.forEach(this.weekDaysOptions, function (day) {
                    day.selected = <boolean>(
                        _.find(self.frequence.jours, { jour: day.id })
                    );
                });
                this.onDaySelection();
            }
            if (
                this.frequence.frequence == Intervention.EFrequence.Bimensuel &&
                this.frequence.jours.length != 2
            ) {
                this.initDaysArray(2);
            } else if (
                this.frequence.frequence == Intervention.EFrequence.Mensuel &&
                this.frequence.jours.length != 1
            ) {
                this.initDaysArray(1);
            } else if (
                this.frequence.frequence ==
                    Intervention.EFrequence.Bimestriel &&
                this.frequence.jours.length != 6
            ) {
                this.initDaysArray(6);
            } else if (
                this.frequence.frequence ==
                    Intervention.EFrequence.Trimestriel &&
                this.frequence.jours.length != 4
            ) {
                this.initDaysArray(4);
            } else if (
                this.frequence.frequence ==
                    Intervention.EFrequence.Semestriel &&
                this.frequence.jours.length != 2
            ) {
                this.initDaysArray(2);
            } else if (
                this.frequence.frequence == Intervention.EFrequence.Annuel &&
                this.frequence.jours.length != 1
            ) {
                this.initDaysArray(1);
            }
        },
        initDaysArray(size: number) {
            let self = this;
            self.frequence.jours = _.times(size, function () {
                return new RecurrenceIntervention.FrequenceJour({
                    occurrence: RecurrenceIntervention.EOccurrence.first,
                    jour: DateUtils.EWeekDays.monday,
                    mois: DateUtils.EMonths.january,
                    employes: self.recurrenceIntervention.employes,
                    horaire_debut: self.recurrenceIntervention.horaire_debut,
                    horaire_fin: self.recurrenceIntervention.horaire_fin,
                });
            });
        },
        onDaySelection() {
            let self = this;
            if (self.frequence.isWeekly()) {
                let selectedDays = _.filter(this.weekDaysOptions, "selected");
                this.frequence.jours = _.map(selectedDays, function (d) {
                    return new RecurrenceIntervention.FrequenceJour({
                        jour: d.id,
                        occurrence: self.selectedOccurrenceHebdo,
                        employes: self.recurrenceIntervention.employes,
                        horaire_debut:
                            self.recurrenceIntervention.horaire_debut,
                        horaire_fin: self.recurrenceIntervention.horaire_fin,
                    });
                });
                this.$forceUpdate();
            }
        },
    },
    watch: {
        "frequence.frequence": {
            immediate: true,
            deep: true,
            handler: function () {
                if (!this.frequence) {
                    return;
                }
                this.initDaysList();
                this.$forceUpdate();
            },
        },
        selectedOccurrenceHebdo: {
            handler: function () {
                let self = this;
                if (self.frequence.isSemiweekly()) {
                    _.forEach(self.frequence.jours, function (jour) {
                        jour.occurrence = self.selectedOccurrenceHebdo;
                    });
                }
            },
        },
    },
};
